import { Controller } from "@hotwired/stimulus"

// Submit controller: submits a form on demand.
//
// Usage A (button inside the target form):
//   = submit_tag "Save",
//       data: { controller: "submit", action: "click->submit#submit" }
//
// Usage B (button outside the form, or multiple forms on the page):
//   = button_tag "Save",
//       type: "button",
//       data: {
//         controller: "submit",
//         submit_form_value: "#my_form",
//         action: "click->submit#submit",
//       }

export default class extends Controller {
  static values = { form: String }

  submit(event) {
    const form = this.#resolveForm()
    if (!form) {
      console.warn("[submit] no form found", { selector: this.formValue })
      return
    }
    event.preventDefault()
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }

  #resolveForm() {
    if (this.hasFormValue) {
      return document.querySelector(this.formValue)
    }
    return this.element.closest("form")
  }
}
